import {Component, OnInit, ViewChild} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../services/application.service';
import {Application} from '../../../domain/onBoarding/application';
import {IId} from '../../../domain/onBoarding/IId';
import {ECatalog} from '../../../enums/ECatalog';
import {CatalogsService} from '../../../services/catalogs.service';
import {ICountry} from '../../../domain/ICountry';
import {ToastaService} from 'ngx-toasta';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';
import {IGeneric} from '../../../domain/IGeneric';
import {merge, Observable, Subject} from 'rxjs';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';

@Component({
  selector: 'app-additional-identification',
  templateUrl: './additional-identification.component.html',
  styleUrls: ['./additional-identification.component.scss']
})
export class AdditionalIdentificationComponent extends CommonComponent implements OnInit {
  application: Application;
  ids: IId[] = [];
  countries: ICountry[];
  selectedCountry: ICountry;
  expirationYears: number[];
  issuingYears: number[] = [];

  @ViewChild('instanceIdentificationCountry') identificationCountry: NgbTypeahead;
  @ViewChild('scrollable-dropdown-menu') scrollableMenu: NgbTypeahead;
  focusIdentificationCountry$ = new Subject<string>();
  clickIdentificationCountry$ = new Subject<string>();

  constructor(
    protected router: Router,
    private applicationService: ApplicationService,
    private catalogsService: CatalogsService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService,
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = this.applicationService.application;
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.getIdentifications();
        this.getCountriesCatalog();
      });
  }

  ngOnInit(): void {
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    const currentYear = new Date().getFullYear();
    this.expirationYears = Array.from({length: 50}, (value, index) => currentYear + index);
    this.issuingYears = Array.from({length: 30}, (value, index) => currentYear - index);
    this.getIdentifications();
    this.getCountriesCatalog();
  }

  searchIdentificationCountry = (text$: Observable<string>): Observable<ICountry[]> => {
    const debouncedText$ = text$.pipe(debounceTime(1), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickIdentificationCountry$.pipe(filter(() => !this.identificationCountry.isPopupOpen()));
    const inputFocus$ = this.focusIdentificationCountry$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => term.length < 1 ? this.countries : this.countries.filter(v => v.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(term.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) > -1).slice(0, 10)
      ));
  }

  itemToString(item: IGeneric): string {
    return item.value;
  }

  assignCountry() {
    this.application.body.identificationCountry = this.selectedCountry.id;
  }

  onSubmit() {
    this.router.navigate(['/onboarding/photos']);
  }

  getIdentifications() {
    this.catalogsService.getCatalog(ECatalog.IDENTIFICATION, 1).subscribe(
      (response: any) => {
        this.ids = response;
      }, error => {
        this.msgError(error);
      }
    );
  }

  getCountriesCatalog() {
    this.catalogsService.getCatalog(ECatalog.COUNTRY).subscribe(
      (response: any) => {
        this.countries = response;
        if (this.application.body.identificationCountry) {
          this.selectedCountry = this.countries.find(it => this.application.body.identificationCountry == it.id);
        }
      }, error => {
        this.msgError(error);
      }
    );
  }
}
